<div class="details" *ngIf="!loading">
  @if (canReschedule) {
  <a class="details__button" (click)="closeDetails(false)" href="javascript:void(0)">
    <img style="transform: rotate(180deg);" src="../../../../assets/img/Icon_Arrow.svg" alt="Arrow" />
    {{'schedule.back' | translate}}
  </a>
  }

  <p id="status-detail-title" class="details__title">{{ 'details.title' | translate }}</p>
  <p class="details__description">{{ 'details.description' | translate }}</p>
  <p class="details__resume">{{ "details.resume" | translate }}
    <span class="details__resume__description">{{ "details.resume-description" | translate }}</span>
  </p>

  <div class="details__cards">
    <!-- Plate -->
    <div class="details__cards__card">
      <p class="details__cards__card__title" id="status-detail-vehicle-name" *ngIf="vehicle && vehicle.modelName">{{
        vehicle.modelYear }} {{ vehicle.modelName }}</p>
      <p class="details__cards__card__title" id="status-detail-vehicle-name" *ngIf="!vehicle || !vehicle.modelName">{{
        schedule.vehicleModelYear }} {{ schedule.vehicleModel }}</p>
      <span class="details__cards__card__description" id="status-detail-vehicle-plate" *ngIf="schedule.vehiclePlate">{{
        "schedule.car.plate" | translate}} {{ schedule.vehiclePlate }}</span>
    </div>

    <!-- Dealer -->
    <div class="details__cards__card">
      <p class="details__cards__card__title">{{ "schedule.dealer" | translate}}</p>
      <span class="details__cards__card__description" id="status-detail-dealer-name">{{ schedule.dealerName }}</span>
      <agenda-customer-ui-card-address id="status-detail-dealer-address" [address]="dealerService.dealer.address"
        [city]="dealerService.dealer.city" [state]="dealerService.dealer.state"
        [country]="dealerService.dealer.countryCode" [postalCode]="dealerService.dealer.zipCode" />
    </div>

    <!-- Attendant -->
    @if (schedule.modality !== modalityEnum.MSV) {
      <div class="details__cards__card">
        <p class="details__cards__card__title">{{ "schedule.advisor" | translate}}</p>
        <span class="details__cards__card__description" id="status-detail-advisor-name">{{ schedule.advisorName }}</span>
      </div>
    }

    <!-- Date and Hour -->
    <div class="details__cards__card">
      <p class="details__cards__card__title">{{ "schedule.date-and-hour" | translate}}</p>
      <span class="details__cards__card__description" *ngIf="customerWaitingInDealer">"{{"schedule.wait_at_dealership" | translate}}"</span>
      <span class="details__cards__card__description" id="status-detail-date">
        {{ getFormattedDate(schedule.scheduleDate) }}
      </span>
      <span class="details__cards__card__description" id="status-detail-hour">{{ schedule.scheduleHour | hour }}</span>
    </div>

    <!-- Pickup And Delivery -->
    @if (schedule.modality !== modalityEnum.DEALER) {
    <div class="details__cards__card">
      <div class="details__cards__card__container-title">
        <p class="details__cards__card__container-title__title">
          {{ "remote-experience.summary.scheduling-data.card."+schedule.modality.toLocaleLowerCase()+".title" |
          translate }}
        </p>
        <img (click)="handlePudModal()" src="../../../../../assets/img/Icon_Information.svg" alt="Icon_Information">
      </div>

      <!-- Driver -->
      <app-driver-information [payloadDriver]="payloadDriver" [modality]="schedule.modality" [showNotFoundContent]="false"
        (hasDriverAssosiated)="onHasDriverAssosiated($event)" />

      @if (!hasDriverAssosiated) {
      <img src="../../../../../assets/img/Icon_Safety_Alert.svg" class="details__cards__card__alert"
        alt="Pickup and delivery date to be defined by dealer">
      <span class="details__cards__card__description" id="status-detail-date-hour-confirm">
        {{ "remote-experience.summary.scheduling-data.card."+schedule.modality.toLocaleLowerCase()+".text" | translate}}
      </span>
      }
    </div>

    <!-- Customer Address -->
    <div class="details__cards__card" *ngIf="userProfile.address?.addressLine1">
      <p class="details__cards__card__title">
        {{ "schedule.your-address" | translate }}
      </p>
      <span class="details__cards__card__description-address__title">
        {{
        'remote-experience.summary.scheduling-data.card.address.' + schedule.modality.toLocaleLowerCase() | translate
        }}
      </span>
      <agenda-customer-ui-card-address [address]="(userProfile.address?.addressLine1 ?? '') + ', ' + (userProfile.address?.addressLine2 ?? '')"
        [city]="userProfile.address?.city ?? ''" [state]="userProfile.address?.state ?? ''" [country]="userProfile.country.countryCode"
        [postalCode]="userProfile.address?.postalCode ?? ''" />
    </div>
    }

    <div class="details__budget">
      <p class="details__budget__title">{{ "schedule.budget-prevision" | translate }}</p>

      <!-- Revision -->
      <div class="details__budget__card" *ngIf="revisionInfo || iolm !== undefined">
        <header class="details__budget__card__header">{{ "schedule.revision" | translate }}</header>
        <section class="details__budget__card__info">
          <div class="details__budget__card__info__title" *ngIf="revisionInfo">
            <span>{{ revisionInfo.serviceName }}</span>

            <ng-container *ngIf="hasPriceInRevision; else onRequest">
              <ng-container *ngIf="revisionInfo.price > 0; else withoutPrice">
                <span>{{ revisionInfo.price | fdsCurrency }}</span>
              </ng-container>
              <ng-template #withoutPrice>
                <ng-container *ngIf="revisionInfo.price === 0 && hasFordProtect; else onRequestWithoutPrice">
                  <span>{{ 'schedule.no-cost' | translate }}</span>
                </ng-container>
                <ng-template #onRequestWithoutPrice>
                  <span>{{ 'schedule.on-request' | translate }}</span>
                </ng-template>
              </ng-template>
            </ng-container>

            <ng-template #onRequest>
              <span>{{ 'schedule.on-request' | translate }}</span>
            </ng-template>
          </div>

          @if (revisionInfo.revisionParts.length > 0) {
          <div class="details__budget__card__info__parts">
            @for (part of revisionInfo.revisionParts; track part.shortPartDesc) {
            @if (part.longPartDesc) {
            <div class="details__budget__card__info__parts__part">
              <span>{{ part.longPartDesc }}</span>
            </div>
            }
            }
          </div>
          }

          <!-- IOLM -->
          <div class="details__budget__card__info__title" *ngIf="iolm !== undefined">
            <span>{{ "schedule.complementary-kit" | translate }}</span>

            <ng-container>
              <ng-container *ngIf="iolm.price > 0; else withoutPrice">
                <span>{{ iolm.price | fdsCurrency }}</span>
              </ng-container>
              <ng-template #withoutPrice>
                <ng-container *ngIf="iolm.price === 0">
                  <span>{{ 'schedule.no-cost' | translate }}</span>
                </ng-container>
              </ng-template>
            </ng-container>
          </div>

          <div class="details__budget__card__info__parts" *ngIf="iolm !== undefined && iolm.revisionParts">
            <div class="details__budget__card__info__parts__part" *ngFor="let part of iolm.revisionParts">
              <span *ngIf="part.longPartDesc">{{ part.longPartDesc | firstLetterCase }} </span>
              <span *ngIf="part.longPartDesc && part.price > 0">{{part.price | fdsCurrency }}</span>
            </div>
          </div>

          <ng-container
            *ngIf="revisionInfo && (hasFordProtect || (revisionInfo.campaigns && revisionInfo.campaigns.length > 0) || revisionInfo.discount > 0)">
            <span class="details__budget__card__info__title">
              {{ "schedule.discounts" | translate }}
            </span>
            <div class="details__budget__card__info__discounts">
              <!-- Campaigns -->
              <div class="details__budget__card__info__discounts__discount"
                *ngFor="let campaign of revisionInfo.campaigns">
                <span>
                  {{ generateCampaignName(campaign.campaignInfo, campaign.discountTypeC, campaign.discountValueA) }}
                </span>
                <span
                  *ngIf="generateDiscountValue(campaign, campaign.discountValueA, campaign.discountTypeC) > 0 && revisionInfo.price > 0"
                  class="text-right">
                  - {{generateDiscountValue(campaign, campaign.discountValueA, campaign.discountTypeC) | fdsCurrency}}
                </span>
                <span
                  *ngIf="generateDiscountValue(campaign, campaign.discountValueA, campaign.discountTypeC) > 0 && revisionInfo.price === 0"
                  class="text-right">
                  {{ 'schedule.price-on-request' | translate }}
                </span>
                <span *ngIf="campaign.discountTypeC === 'VAL' && campaign.discountValueA === 0" class="text-right">
                  {{'schedule.no-cost' | translate}}
                </span>
              </div>
            </div>

            <!-- Ford Protect -->
            <div class="details__budget__card__info__discounts" *ngIf="revisionInfo && hasFordProtect">
              <div class="details__budget__card__info__discounts__discount">
                <span>{{ "status.ford-protect" | translate }} (100%)</span>
                <ng-container *ngIf="hasPriceInRevision; else onRequestFP">
                  <ng-container *ngIf="revisionInfo.price === 0; else revisionHasPrice">
                    <span>{{ 'schedule.no-cost' | translate }}</span>
                  </ng-container>
                  <ng-template #revisionHasPrice>
                    <span>- {{ revisionInfo.price | fdsCurrency }}</span>
                  </ng-template>
                </ng-container>
                <ng-template #onRequestFP>
                  <span>{{ 'schedule.on-request' | translate }}</span>
                </ng-template>
              </div>
            </div>
          </ng-container>

          <!-- Revision Sub Total -->
          <div class="details__budget__card__info__title">
            <span>Subtotal</span>
            <ng-container *ngIf="(hasPriceInRevision || (iolm !== undefined && iolm.price)); else onRequestSubTotal">
              <ng-container
                *ngIf="(revisionPrice > 0 && !hasFordProtect) || (iolm && iolm.price > 0); else noCostOrOnRequest">
                <span *ngIf="hasPriceInRevision">{{ revisionPrice | fdsCurrency }}</span>
                <span *ngIf="!hasPriceInRevision">{{ iolm.price | fdsCurrency }}</span>
              </ng-container>
              <ng-template #noCostOrOnRequest>
                <ng-container
                  *ngIf="revisionPrice === 0 && revisionInfo.price === 0 && revisionInfo.discount !== null; else onRequestOrPrice">
                  <span>{{ 'schedule.no-cost' | translate }}</span>
                </ng-container>
                <ng-template #onRequestOrPrice>
                  <ng-container *ngIf="hasFordProtect; else withoutDiscountFP">
                    <span>{{ 'schedule.no-cost' | translate }}</span>
                  </ng-container>
                  <ng-template #withoutDiscountFP>
                    <span>{{ 'schedule.on-request' | translate }}</span>
                  </ng-template>
                </ng-template>
              </ng-template>
            </ng-container>
            <ng-template #onRequestSubTotal>
              <span>{{ 'schedule.on-request' | translate }}</span>
            </ng-template>
          </div>
        </section>
      </div>

      <!-- Optional Services -->
      <div class="details__budget__card" *ngIf="services && services.length > 0">
        <header class="details__budget__card__header">{{ "schedule.optional-services" | translate }}</header>
        <section class="details__budget__card__info">
          <div class="details__budget__card__info__services">
            <div class="details__budget__card__info__services__service" *ngFor="let service of services">
              <span *ngIf="service.serviceName.length > 20">{{ service.serviceName | decreaseName }}</span>
              <span *ngIf="service.serviceName.length <= 20">{{ service.serviceName }}</span>
              <div class="details__budget__card__info__services__service__discounted-price">
                <div *ngIf="service.price > 0 && service.discount > 0"
                  class="details__budget__card__info__services__service__discounted-price__box">
                  <span class="old-price">{{ service.price | fdsCurrency }}</span>
                  <span>{{ (service.discount) | fdsCurrency}}</span>
                </div>
                <span *ngIf="service.price > 0 && (service.discount === 0 || service.discount === null)">
                  {{ service.price | fdsCurrency}}
                </span>
                <div *ngIf="service.price === 0 || service.price === null">
                  <span *ngIf="service.isCostless">{{ 'schedule.no-cost' | translate }}</span>
                  <span *ngIf="!service.isCostless">{{ 'schedule.on-request' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="details__budget__card__info__title">
            <span>Subtotal</span>
            <div *ngIf="servicesHasPromotions" style="display: flex; flex-direction: column; text-align: right  ;">
              <span class="old-price" *ngIf="!servicesOnRequest">{{ servicesOriginalPrice | fdsCurrency}}</span>
              <span *ngIf="!servicesOnRequest">{{ servicesSubTotal | fdsCurrency}}</span>
              <span *ngIf="servicesOnRequest">{{ 'schedule.on-request' | translate }}</span>
            </div>
            <div *ngIf="!servicesHasPromotions">
              <span *ngIf="!servicesOnRequest && !servicesNoCost && servicesOriginalPrice !== 0">{{
                servicesOriginalPrice | fdsCurrency }}</span>
              <span *ngIf="servicesNoCost && servicesOriginalPrice === 0 && !servicesOnRequest">{{ 'schedule.no-cost' |
                translate }}</span>
              <span *ngIf="servicesOnRequest">{{ 'schedule.on-request' | translate }}</span>
            </div>
          </div>
        </section>
      </div>

      <!-- Pickup And Delivery -->
      <div class="details__budget__card" *ngIf="remoteExperienceService">
        <header class="details__budget__card__header">{{ 'remote-experience.summary.budget.title-card.'+schedule.modality.toLocaleLowerCase() | translate }}</header>

        <section class="details__budget__card__info">
          <div class="details__budget__card__info__services">
            <div class="details__budget__card__info__services__service">
              <span>
                {{ 'remote-experience.summary.budget.title-service.'+schedule.modality.toLocaleLowerCase() | translate }}
              </span>

              <div class="details__budget__card__info__services__service__discounted-price">
                <div>
                  <ng-container *ngIf="remoteExperienceService.discount !== null; else withOutDiscountPUD">
                    <div class="details__budget__card__info__services__service__discounted-price__price">
                      <span class="old-price">
                        {{ remoteExperienceService.price | fdsCurrency }}
                      </span>

                      <ng-container
                        *ngIf="remoteExperienceService.promotionalPrice === remoteExperienceService.price; else showPromotionalPrice">
                        <span>{{'schedule.courtesy' | translate}}</span>
                      </ng-container>
                      <ng-template #showPromotionalPrice>
                        <span *ngIf="remoteExperienceService.discount">{{ remoteExperienceService.discount | fdsCurrency }}</span>
                      </ng-template>

                    </div>
                  </ng-container>
                  <ng-template #withOutDiscountPUD>
                    {{ remoteExperienceService.price | fdsCurrency }}
                  </ng-template>
                </div>
              </div>

            </div>
          </div>

          <!-- SUBTOTAL -->
          <div class="details__budget__card__info__title">
            <span>Subtotal</span>
            <ng-container *ngIf="remoteExperienceService.discount !== null; else subtotalWithOutDiscountPUD">
              <div>
                <ng-container *ngIf="remoteExperienceService.promotionalPrice === remoteExperienceService.price; else noCost">
                  <span>{{'schedule.courtesy' | translate}}</span>
                </ng-container>
                <ng-template #noCost>
                  <span *ngIf="remoteExperienceService.discount">{{ remoteExperienceService.discount | fdsCurrency }}</span>
                </ng-template>
              </div>
            </ng-container>
            <ng-template #subtotalWithOutDiscountPUD>
              <span>{{ remoteExperienceService.price | fdsCurrency }}</span>
            </ng-template>

          </div>

        </section>

      </div>

      <!-- Recall -->
      <div class="details__budget__card" *ngIf="recall">
        <header class="details__budget__card__header">{{ "schedule.recall" | translate | titlecase }}</header>
        <section class="details__budget__card__info">
          <div class="details__budget__card__info__services" *ngFor="let r of recall">
            <div class="details__budget__card__info__services__service">
              <span>{{ "schedule.recall.item" | translate | titlecase }} N° {{ r.recallCampainId }}</span>
              <div class="details__budget__card__info__services__service__discounted-price">
                <span>{{ 'schedule.no-cost' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="details__budget__card__info__title">
            <span>Subtotal</span>
            <span>{{ 'schedule.no-cost' | translate }}</span>
          </div>
        </section>
      </div>

      <!-- Valor final  -->
      <lib-card-display-items-budget
        [title]="'Total'"
        [taxLabel]="'resume.total-without-tax' | translate"
        [items]="itemsTotal"
      />

      <!-- Customer Remark -->
      <div class="details__budget__card" *ngIf="schedule.customerRemarks">
        <header class="details__budget__card__header">{{ "schedule.user-remark" | translate }}</header>
        <section class="details__budget__card__remark">{{ schedule.customerRemarks }}</section>
      </div>

      <!-- Payment Method -->
      @if (schedule.paymentMethod?.length) {
      <div class="details__budget__card payment-method">
        <header class="details__budget__card__header">{{ "schedule.payment.title" | translate }}</header>
        <section class="details__budget__card__info">
          @for (payment of visiblePaymentMethods; track payment.paymentId ?? $index) {
          <app-payment-method-item [payment]="payment" [showPrices]="showPaymentPrices" />
          }
        </section>
      </div>
      }
    </div>
  </div>

  <footer>
    <div class="footer-buttons">
      @if (!canReschedule) {
      <a class="details__button" (click)="closeDetails(false)" href="javascript:void(0)">
        <img style="transform: rotate(180deg);" src="../../../../assets/img/Icon_Arrow.svg" alt="Arrow" />
        {{'schedule.back' | translate}}
      </a>
      }
      <lib-button type="text" (clickButton)="openCancelModal(schedule)">{{'button.cancel' | translate}}</lib-button>
      @if (canReschedule) {
      <lib-button type="primary" [rightIcon]="true" (clickButton)="openRescheduleModal(schedule)">
        {{'button.reschedule' | translate}}
      </lib-button>
      }
    </div>
    <div class="footer-total" *ngIf="quotation">
      <p class="footer-total__title">{{"Total" | uppercase}}</p>
      <div class="footer-total__price">
        <span class="footer-total__price__old-price"
          *ngIf="(!onRequest && totalPrice > subTotal && subTotal !== 0) || (!onRequest && hasApprovedPayment)">
          {{ totalPrice | fdsCurrency }}
        </span>
        <span class="footer-total__price__new-price">
          @if (!onRequest && hasApprovedPayment) {
          {{ 'schedule.payment.total' | translate }}
          } @else {
          <ng-container *ngIf="!onRequest && subTotal > 0; else showTotalPrice">
            {{ subTotal | fdsCurrency}}
          </ng-container>
          <ng-template #showTotalPrice>
            <ng-container *ngIf="!onRequest && totalPrice > 0 && subTotal > 0">{{ totalPrice | fdsCurrency
              }}</ng-container>
          </ng-template>
          <ng-container *ngIf="onRequest">{{ 'schedule.on-request' | translate }}</ng-container>
          <ng-container *ngIf="!onRequest && subTotal === 0">{{ 'schedule.no-cost' | translate }}</ng-container>
          }
        </span>
      </div>
    </div>
  </footer>
  <div id="scroll-page"></div>
</div>

<div id="modal">
  <app-dialog [opened]="openModal" (openedChange)="closeCancelModal()" [modalCenter]="true">
    <div class="modal-cancel">
      <p class="modal-cancel__title">{{ "modal.attention" | translate }}</p>

      <p>
        @if (hasApprovedPayment || hasErrorPayment) {
        {{ "modal-payment.confirm-cancel-subtitle" | translate }}
        <br>
        <br>
        {{ "modal-payment.confirm-cancel-text" | translate }}
        } @else {
        {{ "modal.confirm-cancel" | translate }}
        }
      </p>
    </div>

    <div class="modal-cancel__buttons">
      <a class="modal-cancel__buttons__button-reverse" (click)="closeCancelModal()"
        href="javascript:void(0)">{{'modal.no' | translate}} <img src="../../../../assets/img/Icon_Arrow.svg"
          style="transform: rotateY(180deg);" alt="Arrow"></a>
      <lib-button type="primary" [rightIcon]="true" (clickButton)="cancelSchedule(scheduleToCancel)">
        {{ 'modal.yes' | translate }}
      </lib-button>
    </div>
  </app-dialog>

  <app-dialog [opened]="openReschedule" (openedChange)="closeRescheduleModal()" [modalCenter]="true">
    <p class="modal__title">{{ "schedule.reschedule-title" | translate }}</p>
    <p>{{ "schedule.reschedule-description" | translate }}</p>

    <div class="modal__buttons">
      <lib-button type="primary" [rightIcon]="true" (clickButton)="rescheduleChangeDate(scheduleToCancel)">
        {{ 'schedule.edit-schedule' | translate }}
      </lib-button>
    </div>
  </app-dialog>

  <app-dialog [opened]="openRescheduleUnavailable" (openedChange)="closeRescheduleUnavailableModal()"
    [modalCenter]="true">
    <p class="modal__title">{{ "schedule.reschedule-unavailable-title" | translate }}</p>
    <p class="modal__description">{{ "schedule.reschedule-unavailable-description" | translate }}</p>
    <p class="modal__subdescription">{{ "schedule.reschedule-unavailable-subdescription" | translate }}</p>

    <div class="modal__buttons">
      <lib-button type="primary" (clickButton)="closeRescheduleUnavailableModal()">
        {{ 'schedule.understood' | translate }}
      </lib-button>
    </div>
  </app-dialog>
</div>

<div *ngIf="loading || loadingReschedule || loadingCancel || loadingFP" class="loading">
  <circular-indicator style="align-self: center;" [percentage]="0" [size]="100">
  </circular-indicator>
</div>

<!-- pickup / delivery card modal-->
<div class="modal-pud" *ngIf="pudModal" id="modal">
  <app-dialog [opened]="pudModal" (openedChange)="handlePudModal()" [modalCenter]="true">
    <img src="../../../../../assets/img/Icon_Safety_Alert.svg" width="60" class="icon-alert" alt="Alert">
    <h5 class="modal-pud__title">{{ "status.details.important" | translate }}</h5>
    <br>
    <p class="modal-pud__text">
      {{ "remote-experience.summary.scheduling-data.card.modal."+schedule.modality.toLocaleLowerCase()+".text" |
      translate }}
    </p>
    <div class="modal-pud__buttons">
      <lib-button type="primary" [rightIcon]="true" (clickButton)="handlePudModal()">
        {{'schedule.ok' | translate}}
      </lib-button>
    </div>
  </app-dialog>
</div>
